import { CommunicationWorkflowType } from '@coin/shared/core/util-enums';

export enum WorkflowAction {
  Sign = 'sign',
  Confirm = 'confirm',
  None = 'none'
}

export const WORKFLOW_ACTIONS = {
  [CommunicationWorkflowType.EmployeeConfirmation]: [WorkflowAction.Confirm],
  [CommunicationWorkflowType.EmployeeSignature]: [WorkflowAction.Sign],
  [CommunicationWorkflowType.ManagerConfirmationMercerValidation]: [WorkflowAction.Confirm],
  [CommunicationWorkflowType.ManagerConfirmationEmployeeConfirmation]: [WorkflowAction.Confirm, WorkflowAction.Confirm],
  [CommunicationWorkflowType.ManagerConfirmationEmployeeSignature]: [WorkflowAction.Confirm, WorkflowAction.Sign],
  [CommunicationWorkflowType.ManagerSignatureEmployeeConfirmation]: [WorkflowAction.Sign, WorkflowAction.Confirm],
  [CommunicationWorkflowType.ManagerSignatureEmployeeSignature]: [WorkflowAction.Sign, WorkflowAction.Sign],
  [CommunicationWorkflowType.ManagerConfirmationEmployeeNoActionNeeded]: [WorkflowAction.Confirm, WorkflowAction.None],
  [CommunicationWorkflowType.NoActionNeeded]: [WorkflowAction.None]
};
